import { initLazyLoad, initVideoListener } from "@api/utils_2020";
import('./pb23-carousel--related-products.css');
import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';

const pb23CarouselRelatedProducts = {
    service: null,
    init: function () {        
        initVideoListener();

        $(window).resize(function(){
            let currentWidth = $(window).width();
            if(currentWidth < 769){
                $(".splide__arrows").hide();
            } else {
                $(".splide__arrows").show();
            }
        }).resize();

        $('.pb23-carousel--related-products').each(function(){
            var jsCarouselRelatedProducts = new Splide($('.pb23-carousel--related-products').find('.jsCarouselRelated')[0],{
                type: 'slide',
                autoWidth: false,
                perPage: 6,
                perMove: 1,
                pagination: false,
                autoplay: false,
                infinite: false,
                breakpoints: {
                    1180: {
                        perPage: 4
                    },
                    769: {
                        perPage: null,
                        autoWidth: true,
                        drag: true,
                        arrows: false
                    }
                }
            });
            /*$('.pb23-carousel--related-products').find('.carousel').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: false,
                dots: false,
                prevArrow: '.posts-carousel-prev',
                nextArrow: '.posts-carousel-next',
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1,
                            variableWidth: true
                        }
                    }
                ]
            });*/
            jsCarouselRelatedProducts.mount();
        });
        
        let carouselItens = $('.pb23-carousel--related-products .splide').find('.splide__slide');
        if(carouselItens.length <= 4){
            $(".splide__arrows").hide();
        } else {
            $(".splide__arrows").show();
        }
        
        initLazyLoad();
    }

}

window.loadedComponents.push({ component: 'pb23-carousel--related-products', init: pb23CarouselRelatedProducts.init});
export default() => {
    pb23CarouselRelatedProducts.init();
}